import React from 'react';

import { Tooltip } from 'bsa-ui';
import PropTypes from 'prop-types';
import { MdOutlineCancel } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button, OfflineTooltip } from '@shared/components';
import { intl } from '@shared/localization';

import { openDeclineMultipleAdvancements } from '../../duck';

function DeclineAdvancementsButton({
  disabled,
  className,
  children,
  uppercase,
  personsAdvancements,
  advancementStatus,
  ...rest
}) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      openDeclineMultipleAdvancements(personsAdvancements, advancementStatus),
    );
  };

  return (
    <OfflineTooltip placement="top">
      <Tooltip
        title={<FormattedMessage id="decline.tooltip.message" />}
        trigger={!disabled ? [] : ['hover']}
        placement="top"
      >
        <Button
          id="qa_declineAdvancement"
          className={className}
          disabled={disabled}
          color="info"
          ghost
          noBorder
          fitText
          icon={<MdOutlineCancel />}
          uppercase={uppercase}
          {...rest}
          onClick={handleClick}
        >
          {children ||
            intl.formatMessage(
              {
                id: 'progress.DeclineAdvancementsButton.title',
              },
              { count: personsAdvancements.length },
            )}
        </Button>
      </Tooltip>
    </OfflineTooltip>
  );
}

DeclineAdvancementsButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  personsAdvancements: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  uppercase: PropTypes.bool,
  advancementStatus: PropTypes.string,
};

DeclineAdvancementsButton.defaultProps = {
  uppercase: false,
};

export default DeclineAdvancementsButton;
